import * as React from "react";

import { cn } from "@/lib/utils";

/**
 * Textarea (CHP-522) — the shared multi-line field. Matches `Input`'s geometry
 * (rounded-xl, `border-input`, coral focus ring) so notes/reasons/descriptions
 * stop hand-rolling their own border string (audit X15: ~23 copies, drifted to
 * `border-border`+`rounded`).
 */
export const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, ...props }, ref) => (
  <textarea
    ref={ref}
    className={cn(
      "flex min-h-[80px] w-full rounded-xl border border-input bg-card px-3.5 py-2 text-sm transition-colors placeholder:text-muted-foreground focus-visible:border-ring focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-ring/40 aria-invalid:border-destructive aria-invalid:ring-destructive/20 disabled:cursor-not-allowed disabled:opacity-50",
      className,
    )}
    {...props}
  />
));
Textarea.displayName = "Textarea";
